import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { DELETE } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { DELETE_CLIENT, DELETE_CLIENT_FAILURE, DELETE_CLIENT_SUCCESS } from 'src/redux/clientsReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* DeleteClientFlow(action: { payload: string }): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/clients/${action.payload}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: DELETE,
      params: {}
    })
    yield put(DELETE_CLIENT_SUCCESS(action.payload))
  } catch (error) {
    yield put(DELETE_CLIENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* DeleteClientSaga(): Generator<any, void, any> {
  yield takeLatest(DELETE_CLIENT, DeleteClientFlow)
}
